import { KEYWORDS_ACTIONS } from "../../constants/ActionTypes/ReducerActionTypes/reducer-action-types";

interface InitialState {
  name: string;
  keywordType: string;
  selectedId: number;
}

export const initialState: InitialState = {
  name: "",
  keywordType: "",
  selectedId: null!,
};

type Action =
  | { type: typeof KEYWORDS_ACTIONS.SET_NAME; name: string }
  | { type: typeof KEYWORDS_ACTIONS.SET_TYPE; keywordType: string }
  | { type: typeof KEYWORDS_ACTIONS.SET_SELECTED_ID; selectedId: number };

const reducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case KEYWORDS_ACTIONS.SET_NAME:
      return { ...state, name: action.name };
    case KEYWORDS_ACTIONS.SET_TYPE:
      return { ...state, keywordType: action.keywordType };
    case KEYWORDS_ACTIONS.SET_SELECTED_ID:
      return { ...state, selectedId: action.selectedId };
    default:
      return state;
  }
};

export default reducer;
